var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Zm4.5,12.23L12.23,13.5,9,10.27,5.77,13.5,4.5,12.23,7.73,9,4.5,5.77,5.77,4.5,9,7.73,12.23,4.5,13.5,5.77,10.27,9Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }